/**
 * Root-Component — Bootstrap-Skeleton.
 *
 * Dies ist NUR das Grundgerüst, damit der Build/Deploy laufen. Der eigentliche 3-Schritt-Flow
 * (Format → Inhalt & Texte → Aussehen → Ergebnis) wird gemäss `design_handoff/README.md`
 * (Direction 3a) implementiert und laufend in `docs/DESIGN_FIDELITY.md` gegen den Handoff geprüft.
 */
export default function App() {
  return (
    <main
      data-testid="landing-main"
      className="min-h-dvh bg-[#F4F4EF] text-[#20221E] flex flex-col items-center justify-center px-6 py-12"
    >
      <div className="max-w-md text-center space-y-4">
        <h1 className="font-serif text-3xl font-semibold text-[#1F4A2B]">
          QR-Code-Generator
        </h1>
        <p className="text-base text-[#6B6E66]">
          Bootstrap-Skeleton. Die Umsetzung folgt gemäss Design-Handoff
          (Direction 3a) und `docs/PLAN.md`.
        </p>
        <p className="text-sm text-[#8A8D84]">
          Domain: qr-code.ummah-services.com — kostenlos, ohne Konto, alles im
          Browser.
        </p>
      </div>
    </main>
  );
}
